import { useCallback, useEffect, useRef } from 'react';
import { getChatJob } from '../../api/chatApi';
import { sleep } from './chatArtifactActions';
import { ensureOkResponse } from './chatMessageModel';
import { pollChatJobUntilTerminal } from './chatJobPolling';

async function loadChatJob(jobId) {
  const response = await getChatJob(jobId);
  try {
    return ensureOkResponse(response, 'Unable to load discovery job status.');
  } catch (error) {
    const status = response?.status;
    error.retryable = !response || status === 408 || status === 429 || status >= 500;
    throw error;
  }
}

export default function useChatJobPolling() {
  const mountedRef = useRef(true);

  useEffect(() => {
    mountedRef.current = true;
    return () => {
      mountedRef.current = false;
    };
  }, []);

  const isMounted = useCallback(() => mountedRef.current, []);
  const waitForJob = useCallback((jobId, options = {}) => pollChatJobUntilTerminal({
    jobId,
    initialJob: options.initialJob,
    loadJob: loadChatJob,
    sleep,
    onProgress: options.onProgress,
    isCancelled: () => !mountedRef.current || options.isCancelled?.() === true,
    maxPollsPerWait: options.maxPolls,
    maxPollingChunks: options.maxPollingChunks,
  }), []);

  return { isMounted, waitForJob };
}
